/**
 * Shared flow configuration for BioTemplatePremium routes.
 * Keep production and test routes in sync from one source.
 */

import { buildStripeSuccessReturnRelative } from "@/lib/muchasGraciasSuccessUrl";

export type PremiumCurrency = "ARS" | "USD" | "EUR";

export const PREMIUM_INVITE_FLOW_NAME = "premium_invite";
export const PREMIUM_WEBSITE_FLOW_NAME = "premium_website";

/** ARS one-shot / legacy AR invite. */
const SUCCESS_ARS = "/ar/invitacion/success";
/**
 * Comunidad / invitacion-premium VIP AR post-pago (MP preapproval plan 4d4a2fa0…).
 * → Gracias → Clerk registro → completar perfil → pending.
 */
const SUCCESS_PREMIUM_INVITE_MP = "/invitacion-premium/success?provider=mercadopago&plan=vip";
/** Stripe (USD o EUR): misma página post-pago que Bio Premium Simple (`VITE_MUCHAS_GRACIAS_SUCCESS_PATH`). */
const SUCCESS_STRIPE = buildStripeSuccessReturnRelative();

export function getPremiumInvitePaths(currency: PremiumCurrency): {
  successPath: string;
  cancelPath?: string;
} {
  return {
    // VIP AR (MP hosted) vuelve a success de invitacion-premium → embudo Clerk.
    successPath: currency === "ARS" ? SUCCESS_PREMIUM_INVITE_MP : SUCCESS_STRIPE,
    cancelPath: currency !== "ARS" ? "/invitacion-premium" : "/invitacion-premium?country=AR",
  };
}

export function getPremiumWebsitePaths(currency: PremiumCurrency): {
  successPath: string;
  cancelPath?: string;
} {
  return {
    successPath: currency === "ARS" ? SUCCESS_PREMIUM_INVITE_MP : SUCCESS_STRIPE,
    cancelPath: currency !== "ARS" ? "/invitacion-premium" : "/invitacion-premium?country=AR",
  };
}
